"use strict";

var _ = require("underscore");
var moment = require("moment");
var Reflux = require("reflux");
var ScheduleActions = require("../actions/schedule-actions.js");

var MultiActionStore = require("app/util/flux/multi-action-store");
var ActivityDraft = require("app/util/browser/activity-draft");
var URLUtil = require("app/util/browser/url");

function createStore(instaceKey){
  var scheduleActions = ScheduleActions(instaceKey);

  var store = Reflux.createStore({
    state: {},
    setState: function(state) {
      this.state = _.defaults(state, this.state);
      this.trigger(this.state);
      return this.state;
    },
    getInitialState: function() {
      var env = URLUtil.getPageEnv(window.location);
      var entityId = URLUtil.getEntityId(window.location.search);
      var storagedActivity = ActivityDraft.getActivity("schedule");

      return {
        open: false,
        date: storagedActivity.date,
        time: storagedActivity.time,
        selectedUsers: storagedActivity.selectedUsers,
        disableDefineButton: false,
        elementCaller: null,
        posX: 0,
        posY: 0,
        env: env,
        entityId: entityId
      };
    },
    init: function(){
      this.listenTo(scheduleActions.toggle, this.onToggle);
      this.listenTo(scheduleActions.reposition, this.onReposition);
      this.listenTo(scheduleActions.define, this.onDefine);
      this.listenTo(scheduleActions.clearSelected, this.onClearSelected);
      this.listenTo(scheduleActions.setSelectedUsers, this.onSetSelectedUsers);
      this.listenTo(scheduleActions.setDatetime, this.onSetDatetime);
      this.listenTo(scheduleActions.populate, this.onPopulate);
      this.state = this.getInitialState();
    },
    onPopulate: function(schedule){
      this.setState(schedule);
    },
    onToggle: function(open, elementCaller){
      if(elementCaller){
        var position = $(elementCaller).position();
        var height = $(elementCaller).outerHeight();
        this.state.posX = position.left;
        this.state.posY = position.top + height + 5;
      }

      this.state.open = open || false;
      this.state.elementCaller = elementCaller || null;
      this.trigger(this.state);
    },
    onReposition: function(posX, posY){
      this.state.posX = posX;
      this.state.posY = posY;
      this.trigger(this.state);
    },
    onDefine: function(date, time, selectedUsers){
      var activityFromStorage = ActivityDraft.getActivity();

      this.state.date = date;
      this.state.time = time;
      this.state.selectedUsers = selectedUsers;
      this.state.open = false;

      activityFromStorage.date = date;
      activityFromStorage.time = time;
      activityFromStorage.selectedUsers = selectedUsers;

      ActivityDraft.saveActivity(activityFromStorage);


      this.trigger(this.state);
    },
    onSetSelectedUsers: function(selectedUsers){
      this.state.disableDefineButton = (selectedUsers.length<=0);
      this.state.selectedUsers = selectedUsers;

      this.trigger(this.state);
    },
    onSetDatetime: function(state){
      if(state.validDate) {
        this.state.date = state.validDate;
      }
      if(state.validTime||state.validTime==="") {
        this.state.time = state.validTime;
      }

      this.trigger(this.state);
    },
    onClearSelected: function () {
      this.state.date = moment().format("YYYY-MM-DD");
      this.state.time = "23:59:59";
      this.trigger(this.state);
    }
  });

  return store;
}

module.exports = MultiActionStore.factory(createStore);



// WEBPACK FOOTER //
// ./app/screens/Activity/stores/schedule-store.js